import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Cookie from "@/cookie/cookie.js";

require("@/global/variables.css");

Vue.config.productionTip = false;

const setupTheme = function() {
  const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;

  if(isDarkTheme) {
    document.body.classList.add("dark");
  } else {
    document.body.classList.remove("dark");
  }

  return isDarkTheme;
}

Vue.use(Cookie);

new Vue({
  router,
  render: h => h(App),
  data: {
    config: {
      isDarkTheme: setupTheme()
    }
  },
  watch: {
    "config.isDarkTheme": function(val) {
      if(!document.body.classList.contains("body-transition")) {
        document.body.classList.add("body-transition");
      }

      if(val) {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
    },
    '$route' () {
      scrollTo(0, 0);
    }
  }
}).$mount("#app");